import * as React from 'react';
import { ArticleHeading3, ArticleParagraph1, Image, UIText3 } from '@cian/ui-kit';
import { clsx } from 'clsx';

import * as styles from './PromoItem.css';
import { IPromoItem } from '../../../types/promos/promos';
import { PromoItemLabel } from '../PromoItemLabel';

interface IPromoItemProps {
  promo: IPromoItem;
  onClick?(): void;
}

export const PromoItem: React.FC<IPromoItemProps> = ({ promo, onClick }) => {
  const factoidsInTwoLines = promo.promoProps.length > 3;

  const handleKeyUp = React.useCallback(
    (event: React.KeyboardEvent) => {
      if (onClick && ['Enter', 'Space'].includes(event.code)) {
        onClick();
      }
    },
    [onClick],
  );

  return (
    <article className={styles['card']} role="button" tabIndex={0} onClick={onClick} onKeyUp={handleKeyUp}>
      <div className={styles['top-content']}>
        <div>
          <div className={styles['labels']}>
            {promo.labels.map(({ text, type }) => (
              <PromoItemLabel key={type} newbuildingIds={promo.newbuildingIds} text={text} type={type} />
            ))}
          </div>
          <ArticleHeading3 as="h3">{promo.promoName}</ArticleHeading3>
          <div className={styles['provider']}>
            <ArticleParagraph1>{promo.providerName}</ArticleParagraph1>
          </div>
        </div>
        <div className={styles['logo']}>
          <Image src={promo.providerLogo} height="100%" width="100%" />
        </div>
      </div>
      {promo.promoProps.length > 0 && (
        <ul
          className={clsx(styles['bottom-content'], { [styles['two-lines']]: factoidsInTwoLines })}
          data-testid="PromoItemFactoids"
        >
          {promo.promoProps.map((prop, index) => (
            <li className={styles['factoid']} key={index}>
              <UIText3 color="gray60_100">{prop.title}</UIText3>
              <ArticleParagraph1>{prop.value}</ArticleParagraph1>
            </li>
          ))}
        </ul>
      )}
    </article>
  );
};

PromoItem.displayName = 'PromoItem';
